import React, { PureComponent } from 'react';
import { Translate } from 'react-localize-redux';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { getVal } from 'react-redux-firebase';
import withDatabase from '../../hocs/with-database';
import Indicator from '../../components/indicator';
import Button from '../../components/button';
import { DEFAULT_COLOURS } from '../../constants';

/**
 * Time Slot Presentational Component
 */
class SelectPlace extends PureComponent {
  state = {
    percent: null
  };
  constructor(props) {
    super(props);

  }
  /**
   * @inheritdoc
   */
  render() {

    let buttons = this.props.places || [];
    if ( !buttons || Object.keys(buttons).length <= 0 ){
      return (<Indicator spin />)
    }

    return (
      <Translate>
        {({ translate }) => (
          <>
          {buttons && buttons.map((value, index) => {
            return (
                <Button
                  key={index}
                  disabled={!value.isSelected}
                  onClick={(targeId)=>this.props.onClick(value.gameId)}
                  style={{background:DEFAULT_COLOURS.primary}}
                  >
                  { value.isSelected ? '〇' : '×'} {value.place}
                </Button>

            )
          })}
          </>
        )}
      </Translate>
    );
  }
}

SelectPlace.propTypes = {
  gameId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => ({
  gameId: state.global.gameId,
  places:makePlaces( state )
});

function makePlaces( state ){
  let data = getVal(state.firebase.data, `/games/${state.global.gameId}/places`);
  let json = [];
  for( let key in data ){
    json.push({ gameId: key, place: data[key].name, isSelected : data[key].isSelected });
  }
  return json;

}


export default compose(
  withDatabase,
  connect(mapStateToProps, null),

)(SelectPlace);
